import { Component } from '@angular/core'

@Component({
  selector: 'icon-us-flag',
  templateUrl: './us-flag.icon.html',
})
export class USFlagIconComponent {}
